module.exports = __webpack_public_path__ + "static/media/quiz.bd929c8a.svg";